import NBXPayments from 'services/payments.service';
import { buildTransform } from './transformTaxRecords';

const typeMap = {
  PAYMENT: 'Payment'
};

const transform = buildTransform(typeMap);
export const fetchPaymentsTaxRecords = year =>
  NBXPayments.getTaxReport(year).then(records => records.map(transform));
